import { defineLevel } from './types';

// Generated by scripts/pixelate-image.mjs from "scripts/source-images/gem.png" at grid size 8.
// Do not hand-edit targetColors — regenerate from the source image instead.
export const level: ReturnType<typeof defineLevel> = defineLevel({
  name: "Gem",
  pickShape: 'flood',
  floodLimit: 8,
  targetColors: [
    ['blue', 'blue', 'blue', 'blue', 'blue', 'purple', 'purple', 'purple'],
    ['green', 'blue', 'blue', 'blue', 'blue', 'purple', 'purple', 'purple'],
    ['green', 'green', 'blue', 'blue', 'blue', 'purple', 'purple', 'purple'],
    ['green', 'green', 'green', 'blue', 'purple', 'purple', 'purple', 'purple'],
    ['green', 'green', 'green', 'yellow', 'red', 'red', 'red', 'red'],
    ['green', 'green', 'yellow', 'yellow', 'red', 'red', 'red', 'red'],
    ['green', 'yellow', 'yellow', 'yellow', 'yellow', 'red', 'red', 'red'],
    ['yellow', 'yellow', 'yellow', 'yellow', 'yellow', 'red', 'red', 'red'],
  ],
});
